<template>
  <div class="min-h-screen bg-gradient-to-br from-blue-600 to-blue-800">
    <slot />
  </div>
</template>
